import React, { useState, useEffect, useRef } from "react";
import { Container, Col, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import { Loading } from '../../share/loading'
import { BsPlusLg } from "react-icons/bs";
import * as Yup from 'yup'
import '../../share/form.css';
import { NumberWithCommas } from '../../share/NumberWithCommas'
import Swal from 'sweetalert2'
import { v4 as uuidv4 } from "uuid";
import CreateTableComponent from "../../share/CreateTableComponent";
import DatePicker, { registerLocale } from "react-datepicker";
import th from 'date-fns/locale/th';
import { th as thBuddhist } from 'date-fns/esm/locale';
import { format } from 'date-fns';
import { addYears } from 'date-fns/esm/fp';
import 'react-datepicker/dist/react-datepicker.css'
import { useSearchParams, useNavigate } from "react-router-dom";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import { NumericFormat } from 'react-number-format';
// import Select from 'react-select';
import { GetVMdDept } from "../../share/api/MasterDataApi";
import { FormikSelect } from "../../share/FormikSelect";
// import DataRegisterComponent from "../../share/DataRegisterComponent";
import Select from 'react-select';
import { ReplaceNullWithEmptyString } from "../../share/ReplaceNullWithEmptyString";

export function SupportAnnounce8Component() {
    const navigate = useNavigate();
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก
    const [searchParams] = useSearchParams();
    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type");
    const [currentSupportForm, setCurrentSupportForm] = useState(null);
    registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })
    const range = (start, end) => {
        return new Array(end - start).fill().map((d, i) => i + start);
    };
    const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
    ];
    const years = range(1963, getYear(new Date()) + 8, 1);
    let getCurrentYear = new Date().getFullYear();
    // registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })
    const [loading, setLoading] = useState(false);
    const [dataAnnounce8, setDataAnnounce8] = useState([]);
    // console.log("dataAnnounce9", dataAnnounce9);
    const [calculateAmount, setCalculateAmount] = useState(0);
    // console.log("calculateAmount", calculateAmount)
    const [countEmployee, setCountEmployee] = useState(0);
    // console.log("countEmployee", countEmployee)
    const [budgetYears] = useState(range(2022, getYear(new Date()) + 8, 1));
    console.log("budgetYears", budgetYears);
    const [lawOcuData, setLawOcuData] = useState([]);
    // console.log(lawOcuData);
    const [testLawOcuData, setTestLawOcuData] = useState([]);
    // console.log(testLawOcuData)
    const [levelLawOcuData, setLevelLawOcuData] = useState([]);
    // const [selectedOptions, setSelectedOptions] = useState();

    const [selectedItem, setSelectedItem] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const [openModalForm, setOpenModalForm] = useState(false);
    const Toggle = () => setOpenModalForm(!openModalForm);
    // ดึง cookie มาใช้
    const user = JSON.parse(localStorage.getItem("userData"))
    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);

    const [userProfile, setUserProfile] = useState(null);
    // console.log("userProfile", userProfile);
    const [userAuthRegister, setUserAuthRegister] = useState([]);

    const [conditionOne, setConditionOne] = useState(null);
    const CustomInput = React.forwardRef((props, ref) => {
        const { className, ...rest } = props;
        return (
            <Input
                {...rest}
                ref={ref}
                className={`rounded-pill text-center input-color ${className}`}
            />
        );
    });

    // สำหรับใส่
    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        GetTitleName()
        GetLawOcu()
        GetCurrentSupportForm(); //ดึงข้อมูลคำขอเงินอุดหนุน
        getProfile();
    }, [])

    const getProfile = async () => {
        try {
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (supportId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue("coordinateName", resJson.dataenum.contactorName);
                formikRef.current?.setFieldValue("coordinatePhone", resJson.dataenum.contactorPhone);
                formikRef.current?.setFieldValue("coordinateMobile", resJson.dataenum.phone);
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }

        } catch (e) {
            console.log("err", e)
        }
    };

    const GetCurrentSupportForm = async () => {
        if (supportId !== "0") {
            let postData = new FormData();
            postData.append("supportId", Number(supportId));
            postData.append("supportTypeId", Number(supportTypeId));
            setLoading(true);
            try {
                let res = await fetch("/api/SupportForm/getSupportFormData", {
                    method: "POST",
                    body: postData
                })
                let resJson = await res.json();
                if (resJson.status == 1) {
                    resJson.dataenum["customerTypeId"] = Number(user.roldId);
                    resJson.dataenum["registerId"] = Number(user.registerId);
                    resJson.dataenum["announce"] = "8";
                    resJson.dataenum["term"] = true;
                    setCalculateAmount(resJson.dataenum.amount);
                    setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    setDataAnnounce8(resJson.dataenum.dataAnnounce8);
                }

            } catch (e) {
                console.log("err", e);
            } finally {
                setLoading(false);
            }
        } else {
            return;
        }
    };
    useEffect(() => {
        calculateSupportAmount();
    }, [dataAnnounce8])


    const calculateSupportAmount = async () => {
        try {
            setLoading(true);
            setCountEmployee(0)
            setCountEmployee(dataAnnounce8.length);
            setCalculateAmount(() => {
                return dataAnnounce8.length * conditionOne
            })
        } catch (e) {

        } finally {
            setLoading(false);
        }

    }



    useEffect(() => {

        const getCondition = async () => {
            let id = 7;
            try {
                let res = await fetch(`api/SupportForm/getConditionSupport/${id}`)
                let resJson = await res.json();
                // console.log(resJson.dataenum);
                // setConditionData(resJson.dataenum);

                resJson.dataenum?.map((condition) => {
                    setConditionOne(condition.condition1);
                    // setConditionTwo(condition.condition2);
                    // setConditionDate(condition.conditionDate);
                })

            } catch (e) {
                // console.log('err => ', e)
            }
        }
        getCondition();
    }, [])

    // ดึง master data สาขาอาชีพ
    async function GetLawOcu() {
        setLoading(true)
        try {
            const res = await fetch("/api/Borrow/getLawOcuData")
            const data = await res.json()
            setLawOcuData(data.dataenum);
            // console.log(data.dataenum);
        } catch (e) {
            // console.log("e => " + e)
        } finally {
            setLoading(false);
        }
    }

    // ดึง master data หน่วยงานกรมพัฒฯ
    async function GetTitleName() {
        const res = await fetch("/api/MasterData/getTitle")
        const data = await res.json()
        setTitleName(data.dataenum);
    }



    const renderCustomHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
        // const year = format(date, 'yyyy', { locale: th });
        return (
            <div className="react-datepicker__custom-header">
                <div className="react-datepicker__custom-header-left">
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--previous"
                        aria-label="previous month"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
                    </button>
                </div>
                <div className="react-datepicker__custom-header-center">
                    {/* {format(date, 'MMMM', { locale: th })} {Number(year) + 543} */}
                    <select
                        value={thaiMonths[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                            changeMonth(thaiMonths.indexOf(value))
                        }
                    >
                        {thaiMonths.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <select
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(value)}
                    >
                        {years.map(option => (
                            <option key={option} value={option}>
                                {Number(option) + 543}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="react-datepicker__custom-header-right">
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--next"
                        aria-label="next month"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
                    </button>
                </div>
            </div>
        );
    };

    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item?.authFullName,
        value: item?.authRegisterId
    })) || [];

    // แบบฟอร์มใหญ่
    const initialValues = {
        // กรณีเลือกประกาศ 9
        detailAnnounce8Ar: dataAnnounce8,
        supportId: "0",
        registerId: Number(user.registerId),
        supportTypeName: "ผู้ประกอบกิจการ/ผู้ประกอบอาชีพ/กลุ่มผู้ประกอบกิจการ",
        announce: "8",
        authRegisterId: 0,
        deptId: "",
        supportName: "",
        supportTypeId: "6",
        customerTypeId: Number(user.roldId),
        customerNo: "",
        personalNo: "",
        businessType: "",
        employeeAmount: "",
        addressNo: "",
        moo: "",
        soi: "",
        street: "",
        provinceCode: "",
        amphurCode: "",
        tumbonCode: "",
        locationId: "",
        postCode: "",
        phone: "",
        mobile: "",
        fax: "",
        email: "",
        amount: calculateAmount,
        paymentName: "",
        // fAuthrisePath: "",
        // fAuthriseIdCardPath: "",
        fOtherPath: "",
        fSsoPath: "",
        term: false,
        budgetYear: String(getCurrentYear),

        // // ตาราง
        // employeeId: "0",
        // employee: "",
    }

    const onSubmit = async (values) => {

        let postData = new FormData();
        if (calculateAmount !== 0) {

            postData.append("amount", calculateAmount)
            Object.entries(values).forEach(([key, value]) => {
                if (key.endsWith("8Ar")) {
                    postData.append(key, JSON.stringify(dataAnnounce8));
                } else {
                    postData.append(key, value);
                }
            });
            // console.log(postData);

            try {
                let res = await fetch("/api/SupportForm/saveSupportForm", {
                    method: "POST",
                    body: postData
                });

                let resJson = await res.json();
                // console.log(resJson.dataenum);

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/supporting/")
                        }
                    })
                } else {
                    Swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e)
            }
        } else {
            Swal.fire({
                icon: "info",
                title: "กรุณากรอกรายชื่อลูกจ้าง",
                allowOutsideClick: false,
                allowEscapeKey: false,
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }

    }

    const validationSchema = Yup.object().shape({
        deptId: Yup.string()
            .required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),

        // businessType:Yup.string()
        //     .required("กรุณากรอกประกอบกิจการประเภท"),
        employeeAmount: Yup.number()
            .typeError("จำนวนลูกจ้างต้องเป็นตัวเลขเท่านั้น")
            .required("กรุณากรอกจำนวนลูกจ้าง"), //จำนวนลูกจ้าง

        coordinateName: Yup.string().required("กรุณากรอกชื่อผู้ประสานงาน"),
        coordinatePhone: Yup.string()
            // .matches(/^[0-9]{10}$/, "เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น")
            .required("กรุณากรอกเบอร์โทรศัพท์ผู้ประสานงาน"),
        coordinateMobile: Yup.string()
            // .matches(/^[0-9]{10}$/, "เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น")
            .required("กรุณากรอกเบอร์โทรศัพท์มือถือผู้ประสานงาน"),
        coordinateFax: Yup.string(),
        // .matches(/^[0-9]{10}$/, "เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น"),
        coordinateEmail: Yup.string()
            .email("รูปแบบอีเมลไม่ถูกต้อง")
            .required("กรุณากรอกอีเมลผู้ประสานงาน"),
        paymentName: Yup.string()
            .required("กรุณากรอก"),
        // fAuthrisePath:Yup.mixed(),
        // fAuthriseIdCardPath:Yup.mixed(),
        // fOtherPath:Yup.mixed(),
        // fSsoPath:Yup.mixed(), 
        // fAuthrisePath: Yup.mixed().when('file', {
        //     is: value => value !== undefined && value !== null,
        //     then: Yup.mixed()
        //         .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
        //             return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        //         })
        //         .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 10MB', value => {
        //             const maxSize = 10000000;
        //             return !value || value.size <= maxSize;
        //         }),
        // }),
        // fAuthriseIdCardPath: Yup.mixed().when('file', {
        //     is: value => value !== undefined && value !== null,
        //     then: Yup.mixed()
        //         .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
        //             return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        //         })
        //         .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 10MB', value => {
        //             const maxSize = 10000000;
        //             return !value || value.size <= maxSize;
        //         }),
        // }),
        fOtherPath: Yup.mixed().when('file', {
            is: value => value !== undefined && value !== null,
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 10MB', value => {
                    const maxSize = 10000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        fSsoPath: Yup.mixed().when('file', {
            is: value => value !== undefined && value !== null,
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 10MB', value => {
                    const maxSize = 10000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        term: Yup.bool()
            .oneOf([true], "กรุณายอมรับข้อตกลง"),
    })

    const announce9InitialValues = {
        id: "",
        titleEmployee: "",
        employeeFullName: "",
        certificateNo: "",
        certificateDate: "",
        lawOcupationId: "",
        testOcupationId: "",
        testOcupationLevel: "",
        payRate: "",
        payRateAmount: "",

        payRateStartDate: "",
        payRateEndDate: "",

    }

    const announce9SubmitForm = (values, actions) => {
        // console.log(values)
        Toggle(!openModalForm);
        if (values.id !== "") {
            setDataAnnounce8((old) =>
                old.map((row) => {
                    if (row.id === values.id) {
                        return {
                            ...values,
                            id: values.id,
                        };
                    }
                    return row;
                })
            );
        } else {
            let pre = {
                ...values,
                id: uuidv4(),
            };
            // console.log(pre)
            setDataAnnounce8((prev) => [...prev, pre]);
            actions.resetForm();
        }
    }

    const announce9ValidationSchema = Yup.object().shape({
        titleEmployee: Yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
        employeeFullName: Yup.string().required("กรุณากรอกชื่อ-สกุล"),
        certificateNo: Yup.string().required("กรุณาระบุเลขที่หนังสือรับรอง"),
        certificateDate: Yup.date().required("กรุณาเลือกวันที่ออกหนังสือรับรอง"),
        lawOcupationId: Yup.string().required("กรุณาเลือกสาขาอาชีพ"),
        testOcupationId: Yup.string().required("กรุณาเลือกสาขา"),
        testOcupationLevel: Yup.string().required("กรุณาเลือกระดับ"),
        payRateAmount: Yup.number().typeError("ต้องเป็นตัวเลข").required("กรุณากรอกจำนวนเงิน"),
        payRate: Yup.number().typeError("ต้องเป็นตัวเลข").required("กรุณากรอกจำนวนเงิน"),
        payRateStartDate: Yup.date().required("กรุณาเลือกวันที่เริ่มจ่ายงวดแรก"),
        payRateEndDate: Yup.date().required("กรุณาเลือกวันที่เริ่มจ่ายงวดสุดท้าย"),

    })


    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId == "0" ? false : true}
        // enableReinitialize
        >
            {({ setFieldValue, values, touched, errors, isValid, handleBlur, handleChange }) => {
                const findPersonalId = () => {
                    if (values?.authRegisterId != 0) {
                        const found = userAuthRegister?.find(item => item.authRegisterId == values?.authRegisterId);
                        return found?.authPersonalId
                    }
                }
                // console.log("values", values);
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">

                                <Form className='p-5 mb-4'>

                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className='customer-type text-center px-5'
                                    >
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                                        กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>

                                    <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    {/* <DataRegisterComponent /> */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน

                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.entrepreneurName ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            เลขทะเบียนนิติบุคคล
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.customerNo ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ประเภทกิจการ
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.businessType ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                    <FormGroup className="mt-3">
                                        <Label
                                            for="dept">
                                            ยื่นคำขอที่
                                            <span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.deptId}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>

                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>



                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    <FormGroup row>
                                        <Label
                                            for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.authRegisterId &&
                                                errors.authRegisterId ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.authRegisterId}
                                                </span>
                                            ) : null}

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Field
                                                    name="authRegisterId"
                                                    component={FormikSelect}
                                                    options={authRegisterOptions}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                />
                                            </div>

                                        </div>

                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="titleId">
                                            เลขบัตรประจำตัวประชาชน

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Input
                                                    className="rounded-pill text-center input-color"
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    disabled
                                                    value={findPersonalId()}
                                                />

                                            </div>
                                        </div>
                                    </FormGroup>
                                    <Label
                                        for="employeeAmount">จำนวนลูกจ้าง
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {touched.employeeAmount && errors.employeeAmount ?
                                            <span
                                                className="text-left text-danger mx-1">
                                                {errors.employeeAmount}
                                            </span> : null
                                        }
                                    </Label>
                                    <Col>
                                        <Input
                                            className={touched.employeeAmount && errors.employeeAmount ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            type="text"
                                            name="employeeAmount"
                                            id="employeeAmount"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values?.employeeAmount}
                                        />
                                    </Col>




                                    {/* ชื่อผู้ประสานงาน */}
                                    <FormGroup className="mt-3">
                                        <Label
                                            for="contact">ชื่อผู้ประสานงาน

                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.coordinateName && errors.coordinateName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values?.coordinateName}
                                                disabled
                                            />

                                        </Col>
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label
                                                    for="coordinatePhone"
                                                    sm={2}
                                                >
                                                    โทรศัพท์
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        disabled
                                                        className={touched.coordinatePhone && errors.coordinatePhone ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinatePhone}

                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateMobile"
                                                    sm={2}
                                                >
                                                    โทรศัพท์มือถือ
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        type="text"
                                                        className={touched.coordinateMobile && errors.coordinateMobile ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateMobile}
                                                        disabled
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="soi"
                                                    sm={2}
                                                >
                                                    โทรสาร
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        type="text"
                                                        className={touched.coordinateFax && errors.coordinateFax ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateFax}
                                                        disabled
                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateEmail"
                                                    sm={2}
                                                >
                                                    อีเมล
                                                    <span
                                                        className="require-input">
                                                        *
                                                    </span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        type="text"
                                                        className={touched.coordinateEmail && errors.coordinateEmail ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateEmail}
                                                        disabled
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                    {/* ความประสงค์ขอรับเงิน */}
                                    <FormGroup className='mt-3'>
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมเป็นเงินทั้งสิ้นจำนวน (บาท)
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.amount && errors.amount ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.amount}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="amount"
                                            name="amount"
                                            type="text"
                                            // disabled={true}
                                            className={touched.amount && errors.amount ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            disabled={true}
                                            value={NumberWithCommas(calculateAmount)}

                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.paymentName && errors.paymentName ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.paymentName}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={touched.paymentName && errors.paymentName ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values?.paymentName}

                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label
                                            for="fSsoPath">
                                            แบบแสดงรายการส่งเงินสมทบ (สปส.1-10)
                                            ณ เดือนที่เริ่มจ่ายค่าจ้างถึงเดือนที่จ่ายครบ 180 วัน
                                        </Label>
                                        <Input
                                            id="fSsoPath"
                                            name="fSsoPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fSsoPath", e.target.files[0]);
                                                }
                                            }}
                                        // value={values.fSsoPath}
                                        />

                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            เอกสารอื่นๆ (ถ้ามี)
                                        </Label>
                                        <Input
                                            id="fOtherPath"
                                            name="fOtherPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fOtherPath", e.target.files[0]);
                                                }
                                            }}
                                        // value={values.fOtherPath}

                                        />
                                    </FormGroup>



                                    <div className="mt-5">

                                        <Label
                                            style={{ fontWeight: "bold" }}
                                            className='customer-type text-center px-4 w-100'
                                        >
                                            <div>แบบสรุปรายชื่อลูกจ้างที่ส่งเข้ารับการทดสอบและผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ</div>
                                            <div className="d-flex justify-content-center align-items-center flex-wrap">
                                                <div>และจ่ายค่าจ้างตามมาตรฐานฝีมือแห่งชาติ ปี พ.ศ. {" "}</div>
                                                <Field name="budgetYear">
                                                    {({ field, form, meta }) => (
                                                        <Input
                                                            className={meta.error && meta.touched ?
                                                                "input-error rounded-pill text-center input-color w-25 ms-4" :
                                                                "rounded-pill text-center input-color w-25 ms-4"
                                                            }
                                                            type="select"
                                                            {...field}

                                                        >
                                                            {/* <option defaultValue={0}>
                                                                กรุณาเลือกปีงบประมาณ
                                                            </option> */}
                                                            {budgetYears.map((year, i) => (
                                                                <option
                                                                    key={i}
                                                                    value={String(year)}>
                                                                    {year + 543}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    )}
                                                </Field>
                                            </div>

                                        </Label>
                                        <br />
                                        <Formik
                                            initialValues={isEditing === true ? selectedItem : announce9InitialValues}
                                            validationSchema={announce9ValidationSchema}
                                            onSubmit={announce9SubmitForm}
                                            enableReinitialize
                                        >
                                            {({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched, setFieldError, isValid, setFieldTouched, setErrors, setTouched }) => {
                                                // console.log(isEditing);
                                                // console.log("valuessss", values)
                                                console.log("values", values);
                                                console.log("errors", errors);

                                                const calculateDateDay = (date) => {
                                                    // console.log("date", date);
                                                    const year = date.getFullYear();
                                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                                    const day = String(date.getDate()).padStart(2, '0');
                                                    const formattedDate = `${year}-${month}-${day}`;

                                                    // console.log(values.payRateStartDate)
                                                    // console.log("formattedDate", formattedDate)

                                                    let difference = Math.abs(new Date(formattedDate) - new Date(values.payRateStartDate));
                                                    let daysDifference = difference / (1000 * 60 * 60 * 24);
                                                    // console.log("daysDifference", daysDifference);

                                                    // console.log("daysDifference", daysDifference)
                                                    if (daysDifference < 179) {
                                                        Swal.fire({
                                                            icon: "warning",
                                                            title: `ไม่สามารถขอเงินช่วยเหลือหรืออุดหนุนได้ เนื่องจากยังจ่ายค่าจ้างไม่เกิน 180 วัน`,
                                                            text: `กรุณาตรวจสอบข้อมูลอีกครั้ง`,
                                                            allowOutsideClick: false,
                                                            allowEscapeKey: false,
                                                            confirmButtonColor: "#0A66C2",
                                                            confirmButtonText: "ตกลง",
                                                        }).then(() => {
                                                            setFieldValue("payRateEndDate", "")
                                                            setFieldTouched("payRateEndDate", true)
                                                            setFieldError("payRateEndDate", `ไม่สามารถขอเงินช่วยเหลือหรืออุดหนุนได้ เนื่องจากยังจ่ายค่าจ้างไม่เกิน 180 วัน`);
                                                        })

                                                    } else {
                                                        let today = new Date().getFullYear();
                                                        let monthToday = String(new Date().getMonth() + 1).padStart(2, '0');
                                                        let dayToday = String(new Date().getDate()).padStart(2, '0');
                                                        let formatToday = `${today}-${monthToday}-${dayToday}`;
                                                        // console.log("formatToday", formatToday)
                                                        let differenceToday = Math.abs(new Date(formatToday) - new Date(formattedDate));
                                                        let daysDifferenceToday = differenceToday / (1000 * 60 * 60 * 24);
                                                        // console.log("daysDifferenceToday", daysDifferenceToday)
                                                        if (daysDifferenceToday > 90) {

                                                            Swal.fire({
                                                                icon: "warning",
                                                                title: `วันที่จ่ายค่าจ้างงวดสุดท้าย มีจำนวนเกิน 90 วัน`,
                                                                text: `กรุณาตรวจสอบข้อมูลอีกครั้ง`,
                                                                allowOutsideClick: false,
                                                                allowEscapeKey: false,
                                                                confirmButtonColor: "#0A66C2",
                                                                confirmButtonText: "ตกลง",
                                                            }).then(() => {
                                                                setFieldValue("payRateEndDate", "")
                                                                setFieldError("payRateEndDate", `วันที่จ่ายค่าจ้างงวดสุดท้าย มีจำนวนเกิน 90 วัน`);
                                                                setFieldTouched("payRateEndDate", true)
                                                            })

                                                        }
                                                    }
                                                    // console.log("format",typeof(formattedDate))
                                                    // form.setFieldValue(field.name, formattedDate);

                                                    // console.log(values.payRateEndDate)
                                                    // console.log("date", date)

                                                    // if(date === null){
                                                    //   setFieldError("certificate26NoDate", `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `);
                                                    // }else {
                                                    //   const baseDay = Number(conditionDate) * 24 * 60 * 60 * 1000;
                                                    //   let difference = new Date() - date

                                                    //   if(difference > baseDay){
                                                    //     // setFieldError,("certificate26NoDate", true);
                                                    //     Swal.fire({
                                                    //       icon: "warning",
                                                    //       title: `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `,
                                                    //       text: `กรุณาตรวจสอบข้อมูลอีกครั้ง`,
                                                    //       confirmButtonColor: "#0A66C2",
                                                    //       confirmButtonText: "ตกลง",
                                                    //     }).then(() => {
                                                    //       setFieldError("payRateEndDate", `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `);
                                                    //     });
                                                    //   }
                                                    // }
                                                }
                                                async function GetLawOcuDetailOnEdit(lawOccupationCode) {
                                                    let postData = new FormData();
                                                    postData.append("lawOcuId", lawOccupationCode);
                                                    try {
                                                        const res = await fetch("/api/Borrow/getLawOcuDataDetail",
                                                            {
                                                                method: "POST",
                                                                body: postData,
                                                            }
                                                        );
                                                        const data = await res.json();
                                                        setTestLawOcuData(data.dataenum.map((item) => ({
                                                            value: item.testOccupationCode,
                                                            label: item.testOccupationName
                                                        })))
                                                    } catch (e) {
                                                        // console.log("e => " + e);
                                                    }
                                                }

                                                async function GetLawOcuLevelOnEdit(lawOccupationCode, testOccupationCode) {
                                                    let postData = new FormData();
                                                    postData.append("lawOcuId", lawOccupationCode);
                                                    postData.append("testLawOcuId", testOccupationCode);
                                                    try {
                                                        const res = await fetch("/api/Borrow/getLawOcuLevelData",
                                                            {
                                                                method: "POST",
                                                                body: postData,
                                                            }
                                                        );
                                                        const data = await res.json();
                                                        setLevelLawOcuData(data.dataenum);
                                                    } catch (e) {
                                                        // console.log("e => " + e);
                                                    }
                                                }

                                                async function GetLawOcuDetail(e) {
                                                    let postData = new FormData();
                                                    postData.append("lawOcuId", e.target.value);
                                                    try {
                                                        const res = await fetch("/api/Borrow/getLawOcuDataDetail",
                                                            {
                                                                method: "POST",
                                                                body: postData,
                                                            }
                                                        );
                                                        const data = await res.json();
                                                        setTestLawOcuData(data.dataenum.map((item) => ({
                                                            value: item.testOccupationCode,
                                                            label: item.testOccupationName
                                                        })))
                                                    } catch (e) {
                                                        // console.log("e => " + e);
                                                    }
                                                }

                                                async function GetLawOcuLevel(value) {
                                                    // console.log("get level", value);
                                                    // console.log(values.detailTest[index].lawOcupationId)
                                                    let postData = new FormData();
                                                    postData.append("lawOcuId", values.lawOcupationId);
                                                    postData.append("testLawOcuId", value);
                                                    try {
                                                        const res = await fetch("/api/Borrow/getLawOcuLevelData",
                                                            {
                                                                method: "POST",
                                                                body: postData,
                                                            }
                                                        );
                                                        const data = await res.json();
                                                        setLevelLawOcuData(data.dataenum);
                                                    } catch (e) {
                                                        // console.log("e => " + e);
                                                    }
                                                }

                                                async function courseDetailOnEdit(row) {
                                                    console.log("row", row);
                                                    await GetLawOcuDetailOnEdit(row.lawOcupationId)
                                                    await GetLawOcuLevelOnEdit(row.lawOcupationId, row.testOcupationId)
                                                    setIsEditing(true);
                                                    setSelectedItem(row);
                                                    Toggle(!openModalForm);
                                                }

                                                function courseDetailOnDelete(row) {
                                                    setDataAnnounce8((current) =>
                                                        current.filter((obj) => {
                                                            return obj.id !== row.id;
                                                        })
                                                    );
                                                }

                                                const onAddCourseDetail = () => {
                                                    setIsEditing(false);
                                                    setSelectedItem(null);
                                                    resetForm();
                                                    Toggle();
                                                };

                                                const AddDetailCourseBtn = () => {
                                                    return (
                                                        <button
                                                            className="btn border border-1 text-white btn-green"
                                                            // style={{backgroundColor:"#0A66C2"}}
                                                            onClick={() => onAddCourseDetail()}
                                                        >
                                                            <BsPlusLg className="mx-2" />
                                                            เพิ่มข้อมูล
                                                        </button>
                                                    );
                                                };

                                                const COLUMNS = [
                                                    {
                                                        Header: "ลำดับ",
                                                        accessor: (_row, i) => i + 1,
                                                    },
                                                    {
                                                        Header: "ชื่อ-นามสกุล",
                                                        accessor: "employeeFullName",
                                                    },
                                                    {
                                                        Header: "จำนวนเงิน",
                                                        accessor: "payRateAmount",
                                                        Cell: ({ row, value }) => {
                                                            return (
                                                                <div className="text-center">
                                                                    {NumberWithCommas(Number(value))}
                                                                </div>
                                                            );
                                                        },
                                                    },
                                                    {
                                                        Header: "รายละเอียด",
                                                        accessor: "id",
                                                        Cell: ({ row, value }) => {
                                                            return (
                                                                <div className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn border border-1 mx-1"
                                                                        onClick={() =>
                                                                            courseDetailOnEdit(row.original)
                                                                        }
                                                                    >
                                                                        แก้ไข
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn border border-1 mx-1"
                                                                        onClick={() =>
                                                                            courseDetailOnDelete(row.original)
                                                                        }
                                                                    >
                                                                        ลบ
                                                                    </button>
                                                                </div>
                                                            );
                                                        },
                                                    },
                                                ];

                                                return (
                                                    <div className="mt-3">
                                                        <FormGroup>
                                                            <CreateTableComponent
                                                                column={COLUMNS}
                                                                dataInput={dataAnnounce8 ?? []}
                                                                FormInput={AddDetailCourseBtn}
                                                                showEntrie={false}
                                                                showPage={false}
                                                            />
                                                        </FormGroup>
                                                        <Modal
                                                            isOpen={openModalForm}
                                                            toggle={Toggle}
                                                            size="lg"
                                                            centered
                                                            scrollable
                                                            backdrop="static"
                                                            keyboard={false}
                                                            className="modal-bordered"
                                                            // contentClassName="rounded-4 border-0 shadow-lg"
                                                            style={{ maxWidth: "900px", width: "100%" }}
                                                        >
                                                            <ModalHeader
                                                                toggle={Toggle}
                                                                className="styled-modal border-0"
                                                            >
                                                                <div className="fw-bold fs-4">กรุณากรอกข้อมูล</div>
                                                                {/* <div className="text-muted fs-6">กรอกข้อมูลให้ครบถ้วน จากนั้นกด “บันทึก”</div> */}
                                                            </ModalHeader>

                                                            <ModalBody className="form-border pt-3">
                                                                <div className="px-2 px-md-3">
                                                                    <Form autoComplete="off">
                                                                        {/* hidden id */}
                                                                        <Field name="id" type="text" disabled style={{ display: "none" }} />

                                                                        <div className="mb-3">
                                                                            <hr className="my-2" />
                                                                        </div>

                                                                        <div className="container-fluid">
                                                                            <div className="row g-3">
                                                                                {/* คำนำหน้าชื่อ */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            คำนำหน้าชื่อ{" "}
                                                                                            {touched.titleEmployee && errors.titleEmployee ? (
                                                                                                <span className="text-danger">{errors.titleEmployee}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="titleEmployee">
                                                                                            {({ field, meta }) => (
                                                                                                <Input
                                                                                                    type="select"
                                                                                                    {...field}
                                                                                                    className={
                                                                                                        meta.error && meta.touched
                                                                                                            ? "input-error rounded-pill text-center input-color"
                                                                                                            : "rounded-pill text-center input-color"
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue={"คำนำหน้า"}>คำนำหน้า</option>
                                                                                                    {titleName.map((title) => (
                                                                                                        <option key={title.titleCode} value={title.titleCode}>
                                                                                                            {title.titleThai}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </Input>
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* ชื่อ-นามสกุล */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            ชื่อ-นามสกุล{" "}
                                                                                            {touched.employeeFullName && errors.employeeFullName ? (
                                                                                                <span className="text-danger">{errors.employeeFullName}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="employeeFullName">
                                                                                            {({ field, meta }) => (
                                                                                                <Input
                                                                                                    type="text"
                                                                                                    {...field}
                                                                                                    className={
                                                                                                        meta.error && meta.touched
                                                                                                            ? "input-error rounded-pill text-center input-color"
                                                                                                            : "rounded-pill text-center input-color"
                                                                                                    }
                                                                                                />
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* สาขาอาชีพ */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            สาขาอาชีพ{" "}
                                                                                            {touched.lawOcupationId && errors.lawOcupationId ? (
                                                                                                <span className="text-danger">{errors.lawOcupationId}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="lawOcupationId">
                                                                                            {({ field, meta, form }) => (
                                                                                                <Input
                                                                                                    type="select"
                                                                                                    {...field}
                                                                                                    onChange={(e) => {
                                                                                                        handleChange(e);
                                                                                                        GetLawOcuDetail(e);
                                                                                                    }}
                                                                                                    className={
                                                                                                        meta.error && meta.touched
                                                                                                            ? "input-error rounded-pill text-center input-color"
                                                                                                            : "rounded-pill text-center input-color"
                                                                                                    }
                                                                                                >
                                                                                                    {!isEditing ? (
                                                                                                        <option defaultValue={"กรุณาเลือกสาขาอาชีพ"}>
                                                                                                            กรุณาเลือกสาขาอาชีพ
                                                                                                        </option>
                                                                                                    ) : null}
                                                                                                    {lawOcuData.map((lawOcu) => (
                                                                                                        <option
                                                                                                            key={lawOcu.lawOccupationId}
                                                                                                            value={lawOcu.lawOccupationId}
                                                                                                        >
                                                                                                            {lawOcu.lawOccupationName}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </Input>
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* สาขา (react-select) */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            สาขา{" "}
                                                                                            {touched.testOcupationId && errors.testOcupationId ? (
                                                                                                <span className="text-danger">{errors.testOcupationId}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="testOcupationId">
                                                                                            {({ field, form }) => (
                                                                                                <Select
                                                                                                    name={field.name}
                                                                                                    onBlur={field.onBlur}
                                                                                                    onChange={({ value }) => {
                                                                                                        form.setFieldValue(field.name, value);
                                                                                                        GetLawOcuLevel(value);
                                                                                                    }}
                                                                                                    options={testLawOcuData}
                                                                                                    placeholder={
                                                                                                        <div className="input-color text-center">กรุณาเลือกสาขา</div>
                                                                                                    }
                                                                                                    isDisabled={!values.lawOcupationId}
                                                                                                    value={
                                                                                                        testLawOcuData
                                                                                                            ? testLawOcuData.find((option) => option.value === field.value)
                                                                                                            : ""
                                                                                                    }
                                                                                                    className="text-center input-color"
                                                                                                    styles={{
                                                                                                        control: (base) => ({
                                                                                                            ...base,
                                                                                                            borderRadius: "20px",
                                                                                                            borderColor:
                                                                                                                (form.errors[field.name] && form.touched[field.name])
                                                                                                                    ? "#ff0000"
                                                                                                                    : "#ced4da",
                                                                                                        }),
                                                                                                        singleValue: (base) => ({ ...base, color: "#0A66C2" }),
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* ระดับ */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            ระดับ{" "}
                                                                                            {touched.testOcupationLevel && errors.testOcupationLevel ? (
                                                                                                <span className="text-danger">{errors.testOcupationLevel}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="testOcupationLevel">
                                                                                            {({ field, meta }) => (
                                                                                                <Input
                                                                                                    type="select"
                                                                                                    {...field}
                                                                                                    disabled={!values.testOcupationId}
                                                                                                    className={
                                                                                                        meta.error && meta.touched
                                                                                                            ? "input-error rounded-pill text-center input-color"
                                                                                                            : "rounded-pill text-center input-color"
                                                                                                    }
                                                                                                >
                                                                                                    {!isEditing ? (
                                                                                                        <option defaultValue={"กรุณาเลือกระดับ"}>กรุณาเลือกระดับ</option>
                                                                                                    ) : null}
                                                                                                    {levelLawOcuData.map((item) => (
                                                                                                        <option key={item.stdLevelId} value={item.stdLevelId}>
                                                                                                            {item.stdLevelTname}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </Input>
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* เลขที่หนังสือรับรอง */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            เลขที่หนังสือรับรอง{" "}
                                                                                            {touched.certificateNo && errors.certificateNo ? (
                                                                                                <span className="text-danger">{errors.certificateNo}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="certificateNo">
                                                                                            {({ field, meta }) => (
                                                                                                <Input
                                                                                                    type="text"
                                                                                                    {...field}
                                                                                                    className={
                                                                                                        meta.error && meta.touched
                                                                                                            ? "input-error rounded-pill text-center input-color"
                                                                                                            : "rounded-pill text-center input-color"
                                                                                                    }
                                                                                                />
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* วันที่ออกหนังสือรับรอง */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            วันที่ออกหนังสือรับรอง{" "}
                                                                                            {touched.certificateDate && errors.certificateDate ? (
                                                                                                <span className="text-danger">{errors.certificateDate}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="certificateDate">
                                                                                            {({ field, form }) => {
                                                                                                const selected = field.value ? new Date(field.value) : null;
                                                                                                const selectedBE = selected ? addYears(543, selected) : null;
                                                                                                const monthTH = selectedBE ? format(selectedBE, "MMMM", { locale: th }) : null;
                                                                                                const display = selectedBE
                                                                                                    ? `${format(selectedBE, "d")} ${monthTH} ${format(selectedBE, "yyyy")}`
                                                                                                    : null;

                                                                                                return (
                                                                                                    <DatePicker
                                                                                                        selected={selected}
                                                                                                        locale="th-buddhist"
                                                                                                        calendarClassName="thai-buddhist"
                                                                                                        dateFormat="d MMMM yyyy"
                                                                                                        value={display}
                                                                                                        maxDate={new Date()}
                                                                                                        minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                                                                                                        isClearable
                                                                                                        placeholderText="กรุณาเลือก"
                                                                                                        renderCustomHeader={renderCustomHeader}
                                                                                                        onChange={(date) => {
                                                                                                            if (date instanceof Date && !isNaN(date)) {
                                                                                                                const y = date.getFullYear();
                                                                                                                const m = String(date.getMonth() + 1).padStart(2, "0");
                                                                                                                const d = String(date.getDate()).padStart(2, "0");
                                                                                                                form.setFieldValue(field.name, `${y}-${m}-${d}`);
                                                                                                            } else {
                                                                                                                form.setFieldValue(field.name, "");
                                                                                                            }
                                                                                                        }}
                                                                                                        customInput={
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className={
                                                                                                                    touched.certificateDate && errors.certificateDate
                                                                                                                        ? "input-error rounded-pill text-center input-color"
                                                                                                                        : "rounded-pill text-center input-color"
                                                                                                                }
                                                                                                                value={display || ""}
                                                                                                                onChange={() => { }}
                                                                                                                onBlur={field.onBlur}
                                                                                                            />
                                                                                                        }
                                                                                                    />
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* จำนวนเงิน (disabled แสดงผล) */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            จำนวนเงิน{" "}
                                                                                            {touched.payRateAmount && errors.payRateAmount ? (
                                                                                                <span className="text-danger">{errors.payRateAmount}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="payRateAmount">
                                                                                            {({ field, meta }) => (
                                                                                                <div className="input-group">
                                                                                                    {/* <span className="input-group-text rounded-pill rounded-end-0">฿</span> */}
                                                                                                    <Input
                                                                                                        // disabled
                                                                                                        {...field}
                                                                                                        value={Number(values?.payRateAmount ?? 0)}
                                                                                                        className={
                                                                                                            meta.error && meta.touched
                                                                                                                ? "input-error rounded-pill rounded-start-0 text-center input-color"
                                                                                                                : "rounded-pill rounded-start-0 text-center input-color"
                                                                                                        }
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* อัตราค่าจ้าง (แก้ไขได้) */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            อัตราค่าจ้าง{" "}
                                                                                            {touched.payRate && errors.payRate ? (
                                                                                                <span className="text-danger">{errors.payRate}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="payRate">
                                                                                            {({ field, meta }) => (
                                                                                                <div className="input-group">
                                                                                                    {/* <span className="input-group-text rounded-pill rounded-end-0">฿</span> */}
                                                                                                    <Input
                                                                                                        {...field}
                                                                                                        value={Number(values?.payRate ?? 0)}
                                                                                                        className={
                                                                                                            meta.error && meta.touched
                                                                                                                ? "input-error rounded-pill rounded-start-0 text-center input-color"
                                                                                                                : "rounded-pill rounded-start-0 text-center input-color"
                                                                                                        }
                                                                                                    // value={NumberWithCommas(Number(values.payRateAmount))}
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* วันที่เริ่มจ่ายค่าจ้าง */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            วันที่เริ่มจ่ายค่าจ้าง{" "}
                                                                                            {touched.payRateStartDate && errors.payRateStartDate ? (
                                                                                                <span className="text-danger">{errors.payRateStartDate}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="payRateStartDate">
                                                                                            {({ field, form }) => {
                                                                                                const selected = field.value ? new Date(field.value) : null;
                                                                                                const selectedBE = selected ? addYears(543, selected) : null;
                                                                                                const monthTH = selectedBE ? format(selectedBE, "MMMM", { locale: th }) : null;
                                                                                                const display = selectedBE
                                                                                                    ? `${format(selectedBE, "dd")} ${monthTH} ${format(selectedBE, "yyyy")}`
                                                                                                    : null;

                                                                                                return (
                                                                                                    <DatePicker
                                                                                                        selected={selected}
                                                                                                        locale="th-buddhist"
                                                                                                        calendarClassName="thai-buddhist"
                                                                                                        dateFormat="dd MMMM yyyy"
                                                                                                        value={display}
                                                                                                        minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                                                                                                        maxDate={new Date()}
                                                                                                        isClearable
                                                                                                        placeholderText="กรุณาเลือก"
                                                                                                        renderCustomHeader={renderCustomHeader}
                                                                                                        onChange={(date) => {
                                                                                                            if (date instanceof Date && !isNaN(date)) {
                                                                                                                const y = date.getFullYear();
                                                                                                                const m = String(date.getMonth() + 1).padStart(2, "0");
                                                                                                                const d = String(date.getDate()).padStart(2, "0");
                                                                                                                form.setFieldValue(field.name, `${y}-${m}-${d}`);
                                                                                                            } else {
                                                                                                                form.setFieldValue(field.name, "");
                                                                                                            }
                                                                                                        }}
                                                                                                        customInput={
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className={
                                                                                                                    touched.payRateStartDate && errors.payRateStartDate
                                                                                                                        ? "input-error rounded-pill text-center input-color"
                                                                                                                        : "rounded-pill text-center input-color"
                                                                                                                }
                                                                                                                value={display || ""}
                                                                                                                onChange={() => { }}
                                                                                                                onBlur={field.onBlur}
                                                                                                            />
                                                                                                        }
                                                                                                    />
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>

                                                                                {/* วันที่จ่ายค่าจ้างงวดสุดท้าย */}
                                                                                <div className="col-12 col-md-6">
                                                                                    <FormGroup className="mb-0">
                                                                                        <Label className="fw-semibold">
                                                                                            วันที่จ่ายค่าจ้างงวดสุดท้าย{" "}
                                                                                            {touched.payRateEndDate && errors.payRateEndDate ? (
                                                                                                <span className="text-danger">{errors.payRateEndDate}</span>
                                                                                            ) : null}
                                                                                        </Label>
                                                                                        <Field name="payRateEndDate">
                                                                                            {({ field, form }) => {
                                                                                                const selected = field.value ? new Date(field.value) : null;
                                                                                                const selectedBE = selected ? addYears(543, selected) : null;
                                                                                                const monthTH = selectedBE ? format(selectedBE, "MMMM", { locale: th }) : null;
                                                                                                const display = selectedBE
                                                                                                    ? `${format(selectedBE, "dd")} ${monthTH} ${format(selectedBE, "yyyy")}`
                                                                                                    : null;

                                                                                                return (
                                                                                                    <DatePicker
                                                                                                        selected={selected}
                                                                                                        locale="th-buddhist"
                                                                                                        calendarClassName="thai-buddhist"
                                                                                                        dateFormat="dd MMMM yyyy"
                                                                                                        value={display}
                                                                                                        maxDate={new Date()}
                                                                                                        minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                                                                                                        isClearable
                                                                                                        placeholderText="กรุณาเลือก"
                                                                                                        disabled={!values.payRateStartDate}
                                                                                                        renderCustomHeader={renderCustomHeader}
                                                                                                        onChange={(date) => {
                                                                                                            if (date instanceof Date && !isNaN(date)) {
                                                                                                                const y = date.getFullYear();
                                                                                                                const m = String(date.getMonth() + 1).padStart(2, "0");
                                                                                                                const d = String(date.getDate()).padStart(2, "0");
                                                                                                                form.setFieldValue(field.name, `${y}-${m}-${d}`);
                                                                                                            } else {
                                                                                                                form.setFieldValue(field.name, "");
                                                                                                            }
                                                                                                            calculateDateDay(date);
                                                                                                        }}
                                                                                                        customInput={
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className={
                                                                                                                    touched.payRateEndDate && errors.payRateEndDate
                                                                                                                        ? "input-error rounded-pill text-center input-color"
                                                                                                                        : "rounded-pill text-center input-color"
                                                                                                                }
                                                                                                                value={display || ""}
                                                                                                                onChange={() => { }}
                                                                                                                onBlur={field.onBlur}
                                                                                                            />
                                                                                                        }
                                                                                                    />
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormGroup>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* footer */}
                                                                        <ModalFooter className="border-0 d-flex justify-content-center mt-4">
                                                                            <button type="submit" className="btn-blue px-4 py-2 w-100 w-md-50" disabled={!isValid}>
                                                                                บันทึก
                                                                            </button>
                                                                        </ModalFooter>
                                                                    </Form>
                                                                </div>
                                                            </ModalBody>
                                                        </Modal>

                                                    </div>
                                                );
                                            }}
                                        </Formik>

                                    </div>

                                    {/* term */}
                                    <div className='d-flex'>
                                        <Input
                                            type="checkbox"
                                            invalid={errors.term ? true : false}
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values?.term}
                                            checked={values?.term}
                                        />
                                        <Label
                                            for="term"
                                            className='mx-2 customer-type'
                                        >
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>

                                    </div>

                                    <div className='d-flex justify-content-center align-items-center mt-5'>
                                        <button
                                            type="submit"
                                            disabled={values?.term ? false : true}
                                            // disabled={!isValid}
                                            // disabled={!(isValid && dirty)}
                                            className='btn-blue px-4 w-25'
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </div>

                                </Form>
                            </div>

                        ) : (
                            <Loading />
                        )}


                    </Container>


                )
            }}



        </Formik>

    );

}
